var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.9471C0.0320427 8.88364 0.0640854 8.85191 0.0640854 8.78845C0.192256 8.24904 0.640854 7.86829 1.18558 7.86829C8.39519 7.86829 15.6048 7.86829 22.8144 7.86829C23.4553 7.86829 24 8.40769 23.968 9.01056C23.968 9.64516 23.4553 10.1528 22.8144 10.1528C15.6048 10.1528 8.39519 10.1528 1.18558 10.1528C0.608812 10.1528 0.160214 9.77207 0.0640854 9.23267C0.0640854 9.16921 0.0320427 9.10575 0 9.07402C0 9.01056 0 8.97883 0 8.9471Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.028 0.697266C17.6235 0.697266 20.1869 0.697266 22.7503 0.697266C23.231 0.697266 23.6475 0.887644 23.8398 1.33186C24.032 1.74435 24 2.15684 23.7116 2.53759C23.4873 2.91835 23.0708 3.01354 22.6222 3.01354C21.02 3.01354 19.4179 3.01354 17.8478 3.01354C14.3872 3.01354 10.9266 3.01354 7.46595 3.01354C7.01736 3.01354 6.6008 2.91835 6.31242 2.53759C6.02403 2.15684 5.99199 1.74435 6.21629 1.33186C6.44059 0.887644 6.8251 0.697266 7.30574 0.697266C9.32443 0.697266 11.4072 0.697266 13.4579 0.697266C14.0027 0.697266 14.5154 0.697266 15.028 0.697266Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4312 17.2919C15.6689 17.2919 13.8745 17.2919 12.1121 17.2919C11.3751 17.2919 10.8624 16.7525 10.8945 16.0544C10.9265 15.4833 11.4392 15.0073 12.1121 14.9756C12.1442 14.9756 12.2082 14.9756 12.2403 14.9756C15.7009 14.9756 19.1615 14.9756 22.5901 14.9756C23.0387 14.9756 23.4552 15.0708 23.7436 15.4515C24.032 15.8323 24.064 16.2448 23.8718 16.6573C23.6475 17.1015 23.263 17.3236 22.7823 17.3236C20.9879 17.2919 19.1936 17.2919 17.4312 17.2919Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.5947,
    fill: "white",
    transform: "translate(0 0.697266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.394ac0731e20e5e3b559c73bbbfcdd0d.svg";
export { ForwardRef as ReactComponent };